import React, { useState } from 'react';
import './CounselorSection.css';
import Button from '../Button/Button';
import MessageIcon from '../../assets/icons/messageIcon.svg';
import RibbonIcon from '../../assets/icons/Ribbon.svg';
import PhoneIcon from '../../assets/icons/phoneCalling.svg';
import { IoArrowForward } from 'react-icons/io5';
import { FaHeart, FaRegHeart, FaUserCircle } from 'react-icons/fa';
import { useCounsellorDetQuery } from '../../store/api/userApiSlice';
import { useSaveCounsellorMutation, useUnsaveCounsellorMutation } from '../../store/api/userApiSlice';

import CounselorCard from '../Counsellor/CounselorCard';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials } from '../../store/slices/authSlice';

const CounselorSection = () => {
  const { data, isLoading, error } = useCounsellorDetQuery();
    const dispatch = useDispatch();
      const user = useSelector((state) => state.auth.userInfo);
  const token = useSelector((state) => state.auth.token);
  const scrollRef = React.useRef(null);
  const [scrollProgress, setScrollProgress] = React.useState(0);


  // Robust check for different API response structures
  const counselors = data?.counsellors || data?.counsellor || data?.data || (Array.isArray(data) ? data : []) || [];
  
  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const progress = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      setScrollProgress(progress);
    }
  };




  return (
    <div className="counselor-wrapper">
      <section className="counselor-section">
        <div className="counselor-header">
          <h2 className="counselor-heading">Find the Right Counselor for you career.</h2>
          <a href="/counsellor" className="view-all-counselors">
            VIEW ALL <IoArrowForward />
          </a>
        </div>
        
        <p className="counselor-subtext">
          Discover expert counsellors who can help you choose the right course, college, and career direction based on your strengths and aspirations.
        </p>
        
        <div 
          className="counselor-grid" 
          ref={scrollRef}
          onScroll={handleScroll}
        >
          {counselors.slice(0, 8).map((counselor) => (
            <CounselorCard key={counselor._id || counselor.id} counselor={counselor} />
          ))}
        </div>

        {/* Custom Scrollbar */}
        <div 
          className="custom-scrollbar-track"
          style={{
            width: '170px',
            height: '6px',
            background: '#E0E0E0',
            borderRadius: '3px',
            margin: '32px auto 0',
            position: 'relative',
            overflow: 'hidden',
            cursor: 'pointer' // Add pointer cursor
          }}
          onClick={(e) => {
            // Click track to jump
            const track = e.currentTarget;
            const rect = track.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const percentage = x / rect.width;
            if (scrollRef.current) {
               const { scrollWidth, clientWidth } = scrollRef.current;
               scrollRef.current.scrollTo({ left: (scrollWidth - clientWidth) * percentage, behavior: 'smooth' });
            }
          }}
        >
          <div 
            className="custom-scrollbar-thumb"
            style={{
              position: 'absolute',
              left: `${scrollProgress}%`,
              top: 0,
              bottom: 0,
              width: '30%',
              background: '#0B847E',
              borderRadius: '3px',
              transform: `translateX(-${scrollProgress}%)`,
              transition: 'background 0.2s',
              cursor: 'grab'
            }} 
            onMouseDown={(e) => {
               e.stopPropagation(); // Prevent track click
               const startX = e.clientX;
               const startLeft = scrollRef.current.scrollLeft;
               const { scrollWidth, clientWidth } = scrollRef.current;
               const maxScroll = scrollWidth - clientWidth;
               
               // Calculate how many pixels of scroll = 1 pixel of box movement?
               // Actually easier to map mouse movement directly to scroll percentage
               // Track width = 170px.
               // Thumb width = 30% of 170px = 51px.
               // Moveable area = 170 - 51 = 119px? 
               // Simplified: Just Drag logic relative to track width.
               
               const trackWidth = e.currentTarget.parentElement.clientWidth;
               
               const handleMouseMove = (moveEvent) => {
                  const deltaX = moveEvent.clientX - startX;
                  // deltaX in pixels on track. 
                  // How much percentage is that?
                  const deltaPercent = deltaX / trackWidth;
                  
                  // Update scroll
                  scrollRef.current.scrollLeft = startLeft + (deltaPercent * maxScroll * (1 / (1 - 0.3))); // approximate scaling or just use simple factor
                  
                  // Better approach: Calculate new percentage simply
               };
               
               // SIMPLIFIED DRAG:
               // Just listen to mouse move on window and calculating new percentage based on mouse position relative to track
               const trackRect = e.currentTarget.parentElement.getBoundingClientRect();
               
               const onMove = (evt) => {
                  evt.preventDefault();
                  let x = evt.clientX - trackRect.left;
                  // Clamp
                  if (x < 0) x = 0;
                  if (x > trackRect.width) x = trackRect.width;
                  
                  const ratio = x / trackRect.width;
                  scrollRef.current.scrollLeft = maxScroll * ratio;
               };
               
               const onUp = () => {
                 document.removeEventListener('mousemove', onMove);
                 document.removeEventListener('mouseup', onUp);
               };
               
               document.addEventListener('mousemove', onMove);
               document.addEventListener('mouseup', onUp);
            }}
          />
        </div>
      </section>
    </div>
  );
};

export default CounselorSection;
